<template lang="pug">
div
  el-row(:gutter="10")

    el-col(:lg="6", :md="12", :sm="24")
      p.label Nome/Razão social do interessado:
      el-input.input(
        @keyup.native.enter="consultar"
        name="nomeInteressado",
        type="text",
        v-model="filtroSearch.nomeInteressado"
      )

    el-col(:lg="6", :md="12", :sm="24")
      p.label CPF/CNPJ do interessado:
      el-input(
        @keyup.native.enter="consultar"
        type="text",
        name="cpfInteressado",
        v-mask="['###.###.###-##', '##.###.###/####-##']",
        v-model="filtroSearch.cpfInteressado"
        )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Número do processo:
      el-input.input(
        @keyup.native.enter="consultar"
        name="numeroProcesso",
        type="text",
        v-model="filtroSearch.numeroProcesso"
      )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Número do comprovante:
      el-input.input(
        @keyup.native.enter="consultar"
        name="numeroComprovante",
        type="text",
        v-model="filtroSearch.numeroComprovante"
      )

  el-row(:gutter="10")

    el-col(:lg="6", :md="12", :sm="24")
      p.label Período de cadastro:
      el-date-picker.full-width.input.date(
        type="daterange",
        start-placeholder="Data inicial",
        end-placeholder="Data Final",
        format="dd/MM/yyyy",
        name='dataCadastro',
        v-model="dataCadastro",
      )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Tipo de processo:
      el-select(
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        multiple,
        default-first-option=false,
        name="tiposProcesso",
        v-model="filtroSearch.tiposProcesso",
      )
        el-option(
          v-for="item in getOrdered(tiposProcesso)",
          :key="item.id",
          :label="item.nome",
          :value="item.codigo",
        )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Município:
      el-select(
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        multiple,
        default-first-option=false,
        name="municipio",
        collapse-tags,
        v-model="filtroSearch.municipios",
      )
        el-option(
          v-for="item in municipios",
          :key="item.nome",
          :label="item.nome",
          :value="item.id",
        )

    el-col(:lg="6", :md="12", :sm="24")
      p.label Situação do processo:
      el-select(
        @keyup.native.enter="consultar"
        clearable,
        filterable,
        multiple,
        collapse-tags,
        default-first-option=false,
        name="situacoesProcesso",
        v-model="filtroSearch.situacoesProcesso",
      )
        el-option.situacaoSelect(
          v-for="item in getStatusFormatted(status)",
          :key="item.codigo",
          :label="item.nome",
          :value="item.codigo",
        )
  el-row.button-row
    span.limpar(@click="limpar") Limpar
    el-button(type="primary", @click="consultar")
      i.icon(class="fa fa-search")
      | Pesquisar

  h1.title Resultado da consulta

  div.main.hidden-xs-only
    app-listagem-processos-relatorio(
      v-if="processos.content"
      :processos="processos.content",
      :totalItems.sync="processos.totalElements || 0",
      @changePage="changePage",
      @clicked="onClickedProcessoListagem",
      @changeOrder="changeOrder"
      :page-size="pageSize"
      :currentPage="page",
      :loading="loadingTable"
    )

  el-row.button-row
    el-button.right(
      type="default",
      size="small"
      :disabled="disableExportarCSV",
      @click="getCsv",
    )
      i.fal.fa-file-csv
      span &nbsp Exportar CSV
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'
import EnumFormatter from '@/utils/EnumFormatter'
import AppListagemProcessosRelatorio from '@/screens/portal/publico/components/ConsultaListagemProcessos.vue'

export default {

  components: {
    AppListagemProcessosRelatorio
  },

  data () {
    return {
      page: 1,
      disableExportarCSV: true,
      filtroSearch: {
        pagina: 0,
        nomeInteressado: null,
        cpfInteressado: null,
        dataInicio: [],
        dataFim: [],
        tiposProcesso: [],
        municipios: [],
        tipoPesquisa: 'SIMPLIFICADO',
        ordem: 'numeroProcesso',
        numeroProcesso: null,
        numeroComprovante: null
      },
      dataCadastro: [],
      tiposProcesso: [],
      municipios: [],
      status: [],
      setores: [],
      clickedProcesso: {},
      processos: []
    }
  },

  async created () {
    const filterInfo = await this.getFilterInfo()

    this.tiposProcesso = filterInfo.tiposProcesso
    this.municipios = filterInfo.municipios
    this.status = filterInfo.status
    this.consultar()

    this.disableExportarCSV = this.processo > 0
  },

  props: {
    pageSize: {
      type: Number,
      default: 15
    },
    loading: {
      Type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions({
      getCountProcessos: 'processos/getCountProcessos',
      findProcessosByFilter: 'processos/findProcessosByFilter',
      getCsvProcessoPortalTransparencia: 'processos/getCsvProcessoPortalTransparencia',
      getFilterInfo: 'processos/getFilterInfo'

    }),
    getStatusFormatted (control) {
      const selectFormatted = _.orderBy(control)
      return selectFormatted.map(function (status) {
        return {
          nome: EnumFormatter.getStatusFormatado(status),
          codigo: status
        }
      })
    },
    getSetorFormatted (setor) {
      const setores = setor.filter(setor => (setor.codigo !== 'AGENDAMENTO') && (setor.codigo !== 'PARAMETRIZACAO'))
      const selectFormatted = _.orderBy(setores, ['codigo'], ['asc'])
      return selectFormatted
    },
    getOrdered (control) {
      const selectFormatted = _.orderBy(control)
      return selectFormatted
    },
    getTipoFormatado (codigo) {
      return EnumFormatter.getTipoFormatado(codigo)
    },
    async consultar () {
      this.loadingTable = true
      this.filtroSearch.simplificado = false
      this.filtroSearch.pagina = 0
      this.page = 1

      if (this.dataCadastro && this.dataCadastro.length > 1) {
        this.filtroSearch.dataInicio = this.dataCadastro[0]
        this.filtroSearch.dataFim = this.dataCadastro[1]
      } else {
        this.filtroSearch.dataInicio = null
        this.filtroSearch.dataFim = null
      }

      this.processos = await this.findProcessosByFilter(this.filtroSearch)
      this.loadingTable = false
      this.$emit('changeProcessos', this.processos.content.map(item => item.numeroProcesso))
    },

    async changePage (newPage) {
      this.page = newPage
      this.filtroSearch.pagina = newPage - 1

      this.loadingTable = true
      this.processos = await this.findProcessosByFilter(this.filtroSearch)
      this.loadingTable = false
      this.$emit('changeProcessos', this.processos.content.map(item => item.numeroProcesso))
    },

    async limpar () {
      this.filtroSearch = {
        pagina: 0,
        nomeInteressado: null,
        cpfInteressado: null,
        dataInicio: [],
        dataFim: [],
        tiposProcesso: [],
        municipios: [],
        situacoesProcesso: [],
        tipoPesquisa: 'SIMPLIFICADO',
        numeroProcesso: null,
        numeroComprovante: null
      }

      this.page = 1
      this.dataCadastro = []
      this.loadingTable = true

      this.processos = await this.findProcessosByFilter(this.filtroSearch)
      this.loadingTable = false
      this.$emit('changeProcessos', this.processos.content.map(item => item.numeroProcesso))
    },

    /*
     * Função que envia o processo, que veio do componente filho AppListagemProcessosRelatorios,
     * para a tela de relatorios, para ser exibido no modal
     */
    onClickedProcessoListagem (processo) {
      this.$emit('viewProcessosHasClicked', processo)
    },

    // Exporta csv com os dados buscado de acordo com o filtro escolhido
    getCsv () {
      this.getCsvProcessoPortalTransparencia(this.filtroSearch)
    },
    changeOrder (ordem) {
      this.changePage(1)

      if (ordem && ordem.column && ordem.prop) {
        if (ordem.prop === 'localizacoes') {
          this.filtroSearch.ordem = undefined
        } else if (ordem.prop === 'tipo.nome') {
          this.filtroSearch.ordem = 'tipo'
        } else {
          this.filtroSearch.ordem = ordem.prop
        }
        this.filtroSearch.ordemDirecao = ordem.order === 'ascending' ? 'ASC' : 'DESC'
      } else {
        this.filtroSearch.ordem = 'numeroProcesso'
        this.filtroSearch.ordemDirecao = 'DESC'
      }

      this.consultar()
    }

  },

  watch: {
    countProcessos (value) {
      this.disableExportarCSV = !(value > 0)
    }
  }
}

</script>

<style scoped lang="scss">
@import '@/assets/styles/element-variables.scss';
@import '~@/assets/styles/_variables.scss';

.limpar {
  margin-right: 20px;
  color: $--color-primary;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}
.icon {
  margin-right: 7px;
}
.el-select {
  width: 100%;
}
.label {
  margin: 0;
  padding: 12px 0 8px 0px;
}
.button-row {
  margin-top: 10px;
  text-align: right;
}
.right {
  float: right;
  cursor: pointer;
  margin: 10px 0px;
}
.pagination {
    text-align: center;
}
.full-width {
    width: -webkit-fill-available;
}

/* Cards e gráficos */
.cardTotais:nth-child(-n + 2) {
  margin-bottom: 5%;
}

.cardTotais {
  width: 45%;
  margin-right: 20px;
}

.card-graficos {
  border: 2px solid #34495e;
  border-radius: 12px;
  padding: 5px;
  box-shadow: 0px 3px 6px #00000029;
  text-align: center;
}

.dashboard-info{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.dashboard-info-cards {
  width: 50%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 0 5% 0;
  justify-content: space-between;
}

.dashboard-info-graficos {
  width: 50%;
  padding: 0 0 5% 0;
}

.title {
  color: $color-primary;
}

.el-radio-group /deep/ .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
  box-shadow: none;
}

@media only screen and (max-width: 1256px) {
  .dashboard-info {
    flex-direction: column;
  }

  .dashboard-info-cards {
    width: auto;
    padding-right: 0;
  }

  .dashboard-info-graficos {
    width: auto;
  }

  .cardTotais {
    width: 45%;
  }

  .card-graficos {
    margin: 0;
  }

  .cardTotais:nth-child(2n) {
    margin-right: 0;
  }

  .situacaoSelect {
    left: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/Consulta.vue